const host = {
    nameserver:"https://main-app-dev-ohnqz5j3fq-uc.a.run.app"
}
export default host;